import { CommonGet, CommonPost, CommonGetIDServer } from "../../../utils/CommonFetch";

export default {
   
    getAll,
    searchPackage,
    getGroups,
    getFactoriesForDropdown,
    getFactoriesForDropdownByGroupID,
    getAllOperationEntitiesForDropDown,
    getAllUsers,
    GetAllCollectionPoints,
    startSession,
    GetActiveAspNetUser,
    CheckFactoryWeighComleted,
    startSessionWithCompletingFacWeighment
};



async function getAll(){
    const response = await CommonGet('/api/OperationEntity/GetAllFactories', null);
    return response.data;
}

async function searchPackage(data) {
   
    let formData = {
        groupId: parseInt(data.groupID),
        operationEntityId: parseInt(data.operationEntityId),
        userId: parseInt(data.aspNetUserId),
        collectionPointId: parseInt(data.collectionPointID)
    }
    
    const response = await CommonPost('/api/SoS/GetPackgesForSoS', null, formData);
    return response;
}


async function startSession(data) {

    let formData = {
        
        packageID : data.packageID,
        groupID : data.groupID,
        operationEntityID: data.operationEntityID,
        mobileSessionDate: new Date().toISOString(),
        sOSStartBy :1,
        isSOSEnabled : 1,
        sOSStartDateTime: new Date().toISOString(),
        sOSEndDateTime: new Date().toISOString(),
        sOSEndBy :0,
        createdBy :1,
        createdDate: new Date().toISOString(),
        modifiedBy :0,
        modifiedDate: new Date().toISOString()
    }

    const response = await CommonPost('/api/SoS/StartSessionSos', null, formData);
    console.log("Result", response);
    return response;
}


async function getGroups() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    for (let item of Object.entries(response.data)) {
        if(item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"];
        }
    }
    return groupArray;
}

async function getFactoriesForDropdown(){
    var factoryArray = [];
    const response = await CommonGet('/api/Factory/GetAllFactories', null);
    for (let item of Object.entries(response.data)) {
        if(item[1]["isActive"] === true) {
            factoryArray[item[1]["factoryID"]] = item[1]["factoryName"];
        }
    }
    return factoryArray;
}

async function getFactoriesForDropdownByGroupID(groupID){
    var factoryArray = [];
    const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        if(item[1]["isActive"] === true) {
            factoryArray[item[1]["factoryID"]] = item[1]["factoryName"];
        }
    }
    
    return factoryArray;
}


async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getAllUsers(groupID, operationEntityID) {
    var usersArray = [];
    var response = await CommonGetIDServer('/Admin/GetAllTipsUsers', null);
    for (let item of Object.entries(response)) {
       if (item[1]["groupID"] === parseInt(groupID) && item[1]["isActive"] === true && item[1]["operationEntityID"] === parseInt(operationEntityID)) {
            usersArray[item[1]["aspNetUserId"]] = item[1]["userName"]
        }
    }
    return usersArray;

}

async function GetAllCollectionPoints(id, groupID) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["groupID"] === parseInt(groupID) && item[1]["operationEntityID"] === parseInt(id) && item[1]["isActive"] === true  ) {
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }

    return collectionPointArray;
}

async function GetActiveAspNetUser(groupID, operationEntityID) {

    var FilterUserModel = {
        groupID: groupID,
        operationEntityID: operationEntityID
    }
     
    var usersArray = [];
    var response = await CommonPost('/api/User/GetActiveUser', null, FilterUserModel);
  
    for (let item of Object.entries(response.data)) {
          usersArray[item[1]["aspNetUserId"]] = item[1]["userName"]
    }

    return usersArray;

}

async function CheckFactoryWeighComleted(PkgID) {
    const response = await CommonGet('/api/SoS/CheckFactoryWeighmentCompleted', 'packageId=' + PkgID);
    return response;
}

async function startSessionWithCompletingFacWeighment(data) {

    let formData = {
        
        packageID : data.packageID,
        groupID : data.groupID,
        operationEntityID: data.operationEntityID,
        mobileSessionDate: new Date().toISOString(),
        sOSStartBy :1,
        isSOSEnabled : 1,
        sOSStartDateTime: new Date().toISOString(),
        sOSEndDateTime: new Date().toISOString(),
        sOSEndBy :0,
        createdBy :1,
        createdDate: new Date().toISOString(),
        modifiedBy :0,
        modifiedDate: new Date().toISOString()
    }

    const response = await CommonPost('/api/SoS/StartSessionSosWithFactoryWeighment', null, formData);
 
    return response;
}

